import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { CRMTipoAtividade } from 'src/app/models/crm/crmtipo-atividade';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmtipoAtividadeService } from 'src/app/services/crm/crmtipo-atividade.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-tipo-atividade-modal',
  templateUrl: './tipo-atividade-modal.component.html',
  styleUrls: ['./tipo-atividade-modal.component.scss']
})
export class TipoAtividadeModalComponent implements OnInit {
  tipoAtividade = 0;
  tipos: CRMTipoAtividade[] = [];
  tipoSelecionado;
  public config: PerfectScrollbarConfigInterface = {};
  orcamento = false;

  constructor(
    public dialogRef: MatDialogRef<TipoAtividadeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService,
    private spinner: NgxSpinnerService, private tipoAtividadeService: CrmtipoAtividadeService,
    private carregandoService: CarregandoService
  ) { 
    this.orcamento = data.orcamento;
  }

  ngOnInit() {
    this.buscarTipos();
  }

  buscarTipos() {
    this.carregandoService.mostra('buscarTipos');

    this.tipoAtividadeService.consultarTiposAtividade().subscribe(tipos => {
      this.tipos = this.orcamento ? tipos.filter(p => p.vincularOrcamento) : tipos;
      this.carregandoService.esconde('buscarTipos');
    }, (erro) => {
      this.carregandoService.esconde('buscarTipos');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  selelcionar() {
    this.dialogRef.close(this.tipoSelecionado);
  }
}